import { createAction } from "redux-act";
export var notificationReceived = createAction("NOTIFICATION_RECEIVED");
